exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#navbarDropdownMenuLink {\r\n    margin-right: 10px;\r\n}\r\n\r\n.dropdown-menu-lg {\r\n    min-width: 350px;\r\n}\r\n\r\n.progress {\r\n    background-color: antiquewhite !important;\r\n}\r\n\r\n.fa.fa-refresh {\r\n    cursor: pointer;\r\n    margin-top: 5px;\r\n}\r\n\r\n.progress strong {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-header/app-header.component.css
// module id = ../../../../../src/app/components/app-header/app-header.component.css
// module chunks = main